<template>
  <div :class="['flex flex-col items-center']">
    <div class="font-semibold text-2xl won-modal-paragraph-color text-center">
      Your payment is complete! You now have {{ tokens }} tokens.
    </div>

    <div class="text-base won-logo-text-color mt-5">
      A confirmation email should be on its way!
    </div>

    <won-token-success class="mt-10" />
  </div>
</template>

<script>
import WonTokenSuccess from '../../icons/won-token-success.vue'
import { useTokens } from '../../store/token.store'

export default {
  components: { WonTokenSuccess },
  setup() {
    const tokenStore = useTokens()

    return {
      tokens: tokenStore.selectedOption.amount,
    }
  },
}
</script>

<style>
</style>
